import * as types from "../../types";

export default function (state = {}, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_INFO:
            return {
                ...state,
                info: payload
            };
        default:
            return state;
    }
}